export const getFormattedNumber = (number: number | string) =>
  Number(number).toLocaleString('sv-SE');
